import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=2de7d50a&"
import script from "./Tabs.ts?vue&type=script&lang=ts&"
export * from "./Tabs.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports